var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plane_svg__a",
    d: "M0 0h36.04v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(5.98 14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "plane_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plane_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m35.84 13.273-1.762-1.017a.403.403 0 0 0-.414.007L29.6 14.787l-5.885-3.397 9.763-6.243a.402.402 0 0 0-.016-.688L28.23 1.438a.402.402 0 0 0-.325-.035l-13.814 4.43L4.922.54c-1.687-.974-3.737-.592-4.57.85-.833 1.443-.138 3.409 1.55 4.383l24.55 14.174a.404.404 0 0 0 .306.04l7.312-1.959a.401.401 0 0 0 .267-.234l1.673-4.016a.403.403 0 0 0-.17-.504",
    mask: "url(#plane_svg__b)"
  })))));
};
export default SvgPlane;